import styled from 'styled-components';
import { abyssColors } from '@/theme/colors';
import { Typography } from '@mui/material';

export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const SectionTitle = styled(Typography)(() => ({
  fontSize: '14px',
  fontWeight: '500',
  color: abyssColors.primary[500],
  marginTop: '10px',
}));

